import { useState } from 'react';
import { auth, db } from '../config/firebase';
import { createUserWithEmailAndPassword, sendEmailVerification} from 'firebase/auth';
import { addDoc, collection } from 'firebase/firestore';
import { storage } from '../config/firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import {useGeoLocation} from '../components/useGeoLocation';
import { geohashForLocation } from 'geofire-common';
import * as yup from 'yup';
import {useForm} from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ClipLoader } from 'react-spinners';
import Modal from 'react-modal';
import {useNavigate} from 'react-router-dom';

export const Register = () => {

    const [displayPhoto, setDisplayPhoto] = useState(null);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const userRef = collection(db,'users');
    const {locationInfo, locationError} = useGeoLocation();
    const passwordRules = /^(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).+$/;
    const schema = yup.object().shape({
        displayName: yup.string().required('please enter a display name'),
        email: yup.string().email().required('please enter a valid email address'),
        age: yup.number('please specify your age').min(18, 'you must be at least 18 years old to register').max(99,'please specify your age').positive('please specify your age').integer('please specify your age').required('please specify your age'),
        password: yup.string().min(8, 'password must be at least 8 chars').max(20).matches(
      passwordRules,
      'Password must contain at least one number and one special character'
    ).required(),
        confirmPassword: yup.string().oneOf([yup.ref('password'), null], 'passwords do not match').required('password is required'),
        pronouns: yup.string().required('please select your pronouns'),
        sexuality: yup.string().required('please specify your sexuality'),
        role: yup.string().required('please specify your role'),
        lookingFor: yup.array().required('please select at least one option'),
        locationPref: yup.array().required('please select at least one option'),
        bio: yup.string().required('please include your bio')
    });
    const {register, handleSubmit, formState: {errors}} = useForm({
        resolver: yupResolver(schema),
    });
    const [modalOpen, setModalOpen] = useState(false);
  


    const lookingForList = ['relationship','right now','friends','casual','Daddy',
     'leather', 'kink', 'fetish', 'watersports', 'roleplay', 'discreet', 'sauna',
      'public', 'twink', 'bear', 'otter', 'chub', 'crossdresser', 'dating',
      'holding hands', 'body play', 'cuddles', 'kissing', 'oral', 'anal', 'foreplay',
      'bottom', 'top', 'versatile', 'side', 'boyfriend', 'trans', 'chaser', 'old',
      'young', 'hairy', 'smooth', 'anon', 'balaclava', 'glory hole', 'blindfold',
      'handcuffs', 'BDSM', 'conversation', 'voice call', 'video call', 'messaging', 'nudes'] 
  
  const locationPrefList = ['yours', 'mine', 'outside', 'cafe', 'bar', 'other'];

  
    const createUser = async (newUserData) => {
        setIsLoading(true);

  // 1) launch the modal and wait for the result
  const { verified } = await window.ageverif.start({
    forceVerification: true,   // always prompt, even if they verified earlier
    closable: false            // don’t let them close without verifying
  });
  if (!verified) {
    // they closed or failed—just bail out
    setIsLoading(false);
    return;
  }

  // 2) now that they're verified, unblur and continue
  window.ageverifSuccess();
      
    try{
if (!locationInfo?.latitude || !locationInfo?.longitude) {
      throw new Error('Location unavailable');
    }



        const { latitude, longitude } = locationInfo;
        const geohash = geohashForLocation([latitude, longitude], 9);
        const userCredential = await createUserWithEmailAndPassword(auth, newUserData.email, newUserData.password);

        await sendEmailVerification(userCredential.user);

        let url = null;
        
        if(displayPhoto) {
            const imageRef = ref(storage,`userMedia/${userCredential.user.uid}/${userCredential.user.uid + displayPhoto.name}`);
            const snap = await uploadBytes(imageRef,displayPhoto);
            url = await getDownloadURL(snap.ref);
        }
        

        
            await addDoc(userRef, {
            displayName: newUserData.displayName,
            lookingFor: newUserData.lookingFor,
            locationPref: newUserData.locationPref,
            age: newUserData.age,
            role: newUserData.role,
            bio: newUserData.bio,
            pronouns: newUserData.pronouns,
            sexuality: newUserData.sexuality,        
            isOnline:false,
            isPremium:false,
            isStealth:false,
            authUID:userCredential.user.uid,
            displayPhoto: url,
            location:{latitude:latitude , longitude:longitude, geohash }
        })

        setModalOpen(true);
    navigate('/confirmation');

    } catch(err) {
        console.error(err);
        if (err.code === 'auth/email-already-in-use') {
        alert('This email address is already in use. Please use a different one or sign in.');
        setIsLoading(false);
        return;
    }
    } finally {
        setIsLoading(false);

    }
  }; 



    return (
     
     <div className='main register'>

        <div className='aside'><div></div>
        </div>
        
        <div className='register-modal'>
      <Modal
        className='register-success'
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}  
        contentLabel="My Example Modal"           
      >
        <h2>Please check your email for the verification link </h2>
        <button onClick={() => setModalOpen(false)}>
          Close
        </button>
      </Modal>
    </div>
        
        <div className='content has-aside'>
            <h1>Sign up to Flintt.me to claim your 1 month of Premium membership.</h1>
            <p>We will email you when Flintt goes live.</p><br />
            

        <form onSubmit = {handleSubmit(createUser)}>
                
                <div className='details-group'>
                    <span>Enter your email</span><br />
                    <p className="error-message">{errors.email?.message}</p>
                    <label for="email">
                        <input type='email' placeholder='email' id='email'{...register('email')}/>
                    </label>
                    <p >You can change email notification settings under 'Account'.</p>
                </div>
                <div className='details-group'>
                    <span>Choose a password using letters, numbers and special characters of at least 8 characters.</span><br />
                    <p className="error-message">{errors.password?.message}</p>
                    <label for="password">
                        <input type='password' placeholder='password' id='password'{...register('password')}/>
                    </label>
                    <br /><span>Confirm password</span><br />
                    <p className="error-message">{errors.confirmPassword?.message}</p>
                    <label for="confirmPassword">
                        <input type='password' placeholder='confirm password'id='confirmPassword' {...register('confirmPassword')}/>
                    </label>
                </div>
                <div className='details-group'>
                    <span>Display name</span><br />
                    <p className="error-message">{errors.displayName?.message}</p>
                    <label for="displayName">
                        <input type='text' placeholder='display name' id='displayName' {...register('displayName')}/>
                    </label>
                    <p>This is what other users will see your name as.</p>
                    <p>You can edit your display name later under 'My Profile'.</p>
                    <p>We do not recommend using your real name here.</p>
                </div>
                <div className='details-group'>
                    <span>Age</span><br />
                    <p className="error-message">{errors.age?.message}</p>
                    <label for="age">
                        <input type='number' placeholder='age' id='age' min='18'{...register('age')} />
                    </label>
                    <p>Enter your current age.</p>
                </div>
                <div className='details-group'>
                    <fieldset required>    
                        <span>Pronouns</span><br />
                        <p className="error-message">{errors.pronouns?.message}</p>
                            <label for="pronouns">
                                <input type='radio'{...register('pronouns')} value='he/him'/>
                                he/him
                            </label>
                            <label for="pronouns">
                                <input type='radio'value='she/her'{...register('pronouns')} />
                                she/her
                            </label>
                            <label for="pronouns">
                                <input type='radio'value='they/them'{...register('pronouns')}/>
                                they/them
                            </label>
                            <label for="pronouns">
                                <input type='radio' value='other'{...register('pronouns')} />
                                other
                            </label>
                        <p>Choose the pronouns which others should use to refer to you.</p>
                    </fieldset>
                </div>
                <div className='details-group'>
                    <fieldset required>
                        <span>Sexuality</span><br />
                        <p className="error-message">{errors.sexuality?.message}</p>
                        <label for="sexuality">
                            <input type='radio' value='gay' {...register('sexuality')} />
                            Gay
                        </label>
                        <label for="sexuality">
                            <input type='radio'value='bisexual'{...register('sexuality')} />
                            Bisexual
                        </label>
                        <label for="sexuality">
                            <input type='radio' value='pansexual'{...register('sexuality')} />
                            Pansexual
                        </label>
                        <label for="sexuality">
                            <input type='radio'  value='other'{...register('sexuality')} />
                            other
                        </label>
                        <p>Choosing which sexuality you identify as helps other users to discover your profile.</p>
                    </fieldset>
                </div>
                <div className='details-group'>
                    <fieldset required>
                        <span>Role</span><br />
                        <p className="error-message">{errors.role?.message}</p>
                        <label for="role">
                            <input type='radio'value='top'{...register('role')} />
                            top
                        </label>
                        <label for="role">
                            <input type='radio' value='bottom'{...register('role')} />
                            bottom
                        </label>
                        <label for="role">
                            <input type='radio' value='vers'{...register('role')} />
                            vers
                        </label>
                        <label for="role">
                            <input type='radio' value='side'{...register('role')} />
                            side
                        </label>
                        <label for="role">
                            <input type='radio' value='other'{...register('role')} />
                            other
                        </label>
                        <p>This lets other users know your preferences.</p>
                    </fieldset>
                </div>
                <div className='details-group'>
                    <fieldset required>
                        <span>Meet at</span><br />
                        <p className="error-message">{errors.locationPref?.message}</p>
                            {locationPrefList.map(tag => (
                        <label key={tag} for="locationPref">
                        <input
                            type="checkbox"
                            {...register('locationPref')}
                            value={tag}
                        />
                        {tag}
                        </label>
                         ))}
                        <p>Choose your preferred meeting locations.</p>
                    </fieldset>
                </div>
                <div className='details-group'>
                    <fieldset required>
                        <span>Looking for</span><br />
                        <p className="error-message">{errors.lookingFor?.message}</p>
                                {lookingForList.map(tag => (
                            <label key={tag} for="lookingFor">
                            <input 
                                    type="checkbox"
                                    {...register('lookingFor')}
                                    value={tag}
                                />
                                {tag}
                            </label>
                            ))}
                        <p>Which types of connections are you looking to make?</p>
                    </fieldset>
                </div>
                <div className='almost-done'>                
                    <span>You’re almost done!</span><br />
                    <p>We recommend uploading at least one profile picture and writing a short bio to let other users know about yourself.</p>
                </div>
                <div className='details-group'>
                    <span>Bio</span><br />
                    <p className="error-message">{errors.bio?.message}</p>
                    <label for="bio">
                        <input type='text' placeholder='write something about yourself'id='bio'{...register('bio')}/>  
                    </label>
                    <p>This is a space to add likes, dislikes, and a bit of personal information about yourself.</p>              
                </div>
                <div className='details-group'>
                    <span>Upload an image</span><br />
                        <input type='file'  onChange={(e) => setDisplayPhoto(e.target.files[0])} accept="image/*"/>
                    <p>We recommend using a clear, recent photo of yourself. No nudity on display photos, you can add those later.</p>
                </div>
                <div className='details-group'>
                    <input type='checkbox' required />
                    <span>I confirm I agree to the <a href="/terms-of-service">Terms of Service</a> and <a href="/privacy-policy">Privacy Policy</a>.</span>
                </div>
                <div className='almost-done'>                
                    <span>Next step: age verification.</span><br />
                </div>
                <div className='submit-button'>
                    <button type="submit" disabled={isLoading}>
  {isLoading
    ? <ClipLoader size={20} />
    : 'Sign up'}
</button>
                </div>


        </form>
        </div>

        </div>

    );

    


}